import { css } from '@emotion/react';
import { CalsListing } from './CalsListing';

export const ExportToCalendar = ({ data }) => {
	// const [popover, setPopover] = useState(false);

	return (
		<div
			css={[
				css`
					position: relative;
					display: flex;
					flex-direction: column;
					padding: 16px;
				`,
			]}
		>
			{/* <Tooltip content={'Export'} direction={TooltipDirection.TOP}>
				<Button
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						setPopover((popover) => !popover);
					}}
					ghost
					small
					square
				>
					<IconExport />
				</Button>
			</Tooltip>

			{popover && <CalsListing />} */}
			<CalsListing eventData={data} />
		</div>
	);
};
